import { ComponentRendererProps } from "@/store/sagas/types/deviceUnlock";
import DeviceStatusCheckRenderer from "./DeviceStatusCheckRenderer";
import FAQRenderer from "./FAQRenderer";
import SectionRenderer from "./SectionRenderer";

// Page Wrapper Component Renderer
const PageWrapperRenderer: React.FC<ComponentRendererProps> = ({ component, onSubmit, onNavigate, isRecaptchaReady, isRecaptchaEnabled, isSlowNetwork }) => {
  return (
    <main className="flex-1 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {component.details.content.section.map((section, index) => {
          // Handle nested component structures
          if (section.type === 'DEVICE_STATUS_CHECK' && section.details) {
            return (
              <div key={section.id || index} className="mb-12">
                <DeviceStatusCheckRenderer
                  component={{
                    type: 'DEVICE_STATUS_CHECK',
                    display: (section.display as 'DEFAULT') || 'DEFAULT',
                    details: section.details
                  }}
                  onSubmit={onSubmit}
                  onNavigate={onNavigate}
                  isRecaptchaReady={isRecaptchaReady}
                  isRecaptchaEnabled={isRecaptchaEnabled}
                  isSlowNetwork={isSlowNetwork}
                />
              </div>
            );
          }

          if (section.type === 'FAQ' && section.details) {
            return (
              <div key={section.id || index} className="mb-12">
                <FAQRenderer
                  component={{
                    type: 'FAQ',
                    display: (section.display as 'ACCORDION') || 'ACCORDION',
                    details: section.details
                  }}
                />
              </div>
            );
          }

          // Default section rendering
          return (
            <div key={section.id || index} className="mb-12">
              <SectionRenderer
                section={section}
                onSubmit={onSubmit}
                onNavigate={onNavigate}
              />
            </div>
          );
        })}
      </div>
    </main>
  );
};

export default PageWrapperRenderer;